import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {

  constructor(private _translateService: TranslateService) { }

  ngOnInit(): void {
  }

  openUrl(type: string) {
    switch(type){
        case 'support':
            window.open(
                this._translateService.instant('URLS.CONTACT_SUPPORT_URL'),
                '_blank'
            );
        break;
        case 'docs':
            window.open(
                this._translateService.instant('URLS.DOCS'),
                '_blank'
            );
        break;
        default:
            window.open(
                this._translateService.instant('URLS.CONTACT_SUPPORT_URL'),
                '_blank'
            );
        break;
    }
    
  }

}
